import * as __calendar from '@syncfusion/ej2-calendars/calendar';
import * as _base from '@syncfusion/ej2-base';
import * as _buttons from '@syncfusion/ej2-buttons';
import * as __button from '@syncfusion/ej2-buttons/button';

function copy(copied, first, second, deep) {
    var result = copied || {};
    var length = arguments.length;
    if (deep) {
        length = length - 1;
    }
    var _loop_1 = function (i) {
        if (!arguments_1[i]) {
            return "continue";
        }
        var obj1 = arguments_1[i];
        Object.keys(obj1).forEach(function (key) {
            var src = result[key];
            var copy = obj1[key];
            var clone;
            if (deep && (isObject(copy) || Array.isArray(copy))) {
                if (isObject(copy)) {
                    clone = src ? src : {};
                    result[key] = copy({}, clone, copy, deep);
                }
                else {
                    clone = src ? src : [];
                    result[key] = copy([], clone, copy, deep);
                }
            }
            else {
                result[key] = copy;
            }
        });
    };
    var arguments_1 = arguments;
    for (var i = 1; i < length; i++) {
        _loop_1(i);
    }
    return result;
}

__calendar.Calendar.Inject(__calendar.Islamic);

var calendars = {};
copy(calendars, __calendar);

var buttons = {};
copy(buttons, __button);

var base = _base;

export { calendars,base,buttons };